import { Routes } from '@angular/router';
import { WelcomeComponent } from '@tsin-pages/welcome/welcome.component';
import { AuthWrapperComponent } from './layout/auth-wrapper/auth-wrapper.component';
import { ManagementComponent } from '@tsin-pages/management/management.component';
import { adminGuard } from '@tsin-core/guards/admin.guard';
import { otpGuard } from '@tsin-core/guards/otp.guard';
import { preOtpGuard } from '@tsin-core/guards/pre-otp.guard';

export const routes: Routes = [
    // Redirect the empty path to the welcome page
    { path: '', redirectTo: 'welcome', pathMatch: 'full' },
    // Welcome page route
    { path: 'welcome', component: WelcomeComponent },
    {
        path: 'login',
        component: AuthWrapperComponent,
        loadChildren: () => import('./pages/auth/login.routes'),
    },
    {
        path: 'auth',
        component: AuthWrapperComponent,
        loadChildren: () => import('./pages/auth/auth.routes'),
    },
    {
        path: 'verify-email',
        component: AuthWrapperComponent,
        loadChildren: () => import('./pages/auth/verify-email.routes'),
    },
    {
        path: 'create-account',
        loadChildren: () => import('./pages/create-account/create-account.routes'),
    },
    {
        path: 'otp',
        component: AuthWrapperComponent,
        canActivate: [preOtpGuard],
        loadChildren: () => import('./pages/otp/otp.routes'),
    },
    {
        path: 'user',
        canActivate: [otpGuard],
        loadChildren: () => import('./pages/user/user.routes'),
    },
    {
        path: 'management',
        component: ManagementComponent,
        canActivate: [adminGuard, otpGuard]
    },
    // Wildcard route for a 404 page or redirect to welcome
    { path: '**', redirectTo: 'welcome' }
];
